import { render, staticRenderFns } from "./CheckboxRounded.vue?vue&type=template&id=9e67da68&"
import script from "./CheckboxRounded.vue?vue&type=script&lang=ts&"
export * from "./CheckboxRounded.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxRounded.vue?vue&type=style&index=0&id=9e67da68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports